import { BaseDto } from './base.dto';
import { IsDefined, IsInt, IsNotEmpty, IsString, Length} from 'class-validator';
import { OrderReceiptPhotoTypeDto } from './order-receipt-photo-type.dto';
import { Exclude } from 'class-transformer';

export class OrderReceiptPhotoDto extends BaseDto {
  @IsDefined()
  @IsInt()
  orderId: number;

  @IsDefined()
  @IsInt()
  orderReceiptPhotoTypeId: number;

  @IsDefined()
  @IsString()
  @IsNotEmpty()
  @Length(0, 255)
  photoUrl: string;

  @Exclude()
  orderReceiptPhotoType?: OrderReceiptPhotoTypeDto
}
